export enum DrawerType {
  MobileMenu = 'mobileMenu',
  Notifications = 'notifications',
  ProfileMenu = 'profileMenu',
  Filters = 'filters',
  ColumnOptions = 'columnOptions',
  AI = 'AI',
  HelpMenu = 'helpMenu',
}
